export { RatingQuestion } from './rating-question';
